
import React, { useEffect, useState } from 'react';
import OrderDesign from './OrderDesign';
import { API_URL } from './config/apiConfig';


function DemoOrder() {
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchKamikaze = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/orders?faction=Remnants%20of%20Humanity`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const data = await response.json();
        const kamikaze = data.find(o => o.name === 'Supply Marshal');
        setOrder(kamikaze);
      } catch (err) {
        console.error('Failed to fetch Kamikaze order:', err);
      }
    };

    fetchKamikaze();
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ color: 'white' }}>Demo: Kamikaze Order</h2>
      {order ? <OrderDesign order={order} count={0} /> : <div style={{ color: 'white' }}>Loading...</div>}
    </div>
  );
}

export default DemoOrder;
